import {ForwardedRef, forwardRef} from "react";
import {components, OptionProps, SelectInstance, SingleValueProps} from "react-select";

import {Icon} from "@/components/icon/Icon.tsx";
import {Select} from "@/components/select/Select.tsx";
import {SelectOption, SelectProps} from "@/components/select/Select.types.ts";
import {CredentialType, CredentialTypeDisplayDetails, CredentialTypeLabel} from "@/lib/types/credentials.ts";

const CredentialTypeSingleValue = ({children, data, ...props}: SingleValueProps<SelectOption>) => {
  const credentialTypeDetails = CredentialTypeDisplayDetails[data.value as CredentialType];
  return (
    <components.SingleValue {...props} className="d-flex align-items-center" data={data}>
      <Icon size="kpi" icon={credentialTypeDetails.icon} />
      <span className="ms-2">{data.value ? children : "Select credential type..."}</span>
    </components.SingleValue>
  );
};

const CredentialTypeOption = ({children, data, ...props}: OptionProps<SelectOption>) => {
  const credentialTypeDetails = CredentialTypeDisplayDetails[data.value as CredentialType];
  return (
    <components.Option {...props} data={data}>
      <div className="d-flex align-items-center">
        <Icon size="kpi" icon={credentialTypeDetails.icon} />
        <div className="d-flex flex-column ms-2">
          <span>{children}</span>
        </div>
      </div>
    </components.Option>
  );
};

export const CredentialTypeSelect = forwardRef(
  (props: SelectProps, ref: ForwardedRef<SelectInstance<SelectOption, false>>) => {
    return (
      <Select
        options={Object.values(CredentialType).map((s) => ({
          value: s,
          label: CredentialTypeLabel[s],
        }))}
        getOptionValue={({value}) => value}
        getOptionLabel={({value}) => CredentialTypeLabel[value as CredentialType]}
        isSearchable={false}
        components={{Option: CredentialTypeOption, SingleValue: CredentialTypeSingleValue}}
        ref={ref}
        {...props}
      />
    );
  }
);
